import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { GetMagnetKeyInfo, MagnetDynamicReport, PostMagnetSetKeyInfo } from './magnet_set'
import { DataDeadZone, PostMagnetSetKeyDeadZone } from '@libs/types/response'
import { KK } from '@/define/define'
import { SetMagnetSenior } from '../response'

// 发送的数据进行转换
// 注意：必须返回新对象，避免污染调用方持有的同一引用（例如 mgx_set.vue 的 changelist 还要复用原始未缩放的值）。
export const convertTravelToSend_Above6800 = (info: PostMagnetSetKeyInfo): PostMagnetSetKeyInfo => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return info
  return {
    ...info,
    PressNum: info.PressNum > 0 ? (info.PressNum * 2) / 10 : info.PressNum,
    ReleaseNum: info.ReleaseNum > 0 ? (info.ReleaseNum * 2) / 10 : info.ReleaseNum,
    QuickTriggerPressNum: info.QuickTriggerPressNum > 0 ? (info.QuickTriggerPressNum * 2) / 10 : info.QuickTriggerPressNum,
    QuickTriggerReleaseNum: info.QuickTriggerReleaseNum > 0 ? (info.QuickTriggerReleaseNum * 2) / 10 : info.QuickTriggerReleaseNum,
  }
}
// 获取回来的数据进行转换
export const convertTravelFromReceive_Above6800 = (data: GetMagnetKeyInfo[]): GetMagnetKeyInfo[] => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return data
  return data.map((item) => ({
    ...item,
    PressNum: item.PressNum > 0 ? (item.PressNum / 2) * 10 : item.PressNum,
    ReleaseNum: item.ReleaseNum > 0 ? (item.ReleaseNum / 2) * 10 : item.ReleaseNum,
    QuickTriggerPressNum: item.QuickTriggerPressNum > 0 ? (item.QuickTriggerPressNum / 2) * 10 : item.QuickTriggerPressNum,
    QuickTriggerReleaseNum: item.QuickTriggerReleaseNum > 0 ? (item.QuickTriggerReleaseNum / 2) * 10 : item.QuickTriggerReleaseNum,
  }))
}
// 发送的死区数据进行转换
export const convertDeadZoneToSend_Above6800 = (setData: PostMagnetSetKeyDeadZone): PostMagnetSetKeyDeadZone => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return setData
  return {
    ...setData,
    Top: (setData.Top * 2) / 10,
    Bottom: (setData.Bottom * 2) / 10,
  }
}
// 获取回来的死区数据进行转换
export const convertDeadZoneFromReceive_Above6800 = (data: { [key: KK]: DataDeadZone }): { [key: KK]: DataDeadZone } => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return data
  const result: { [key: KK]: DataDeadZone } = {}
  for (const key in data) {
    const item = data[key]
    result[key] = {
      ...item,
      Top: (item.Top / 2) * 10,
      Bottom: (item.Bottom / 2) * 10,
    }
  }
  return result
}
// 校准时行程转换
export const convertTravelForCalibration = (res: MagnetDynamicReport[]): MagnetDynamicReport[] => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return res
  return res.map((item) => ({
    ...item,
    Value: item.Value > 0 ? item.Value * 10 : item.Value,
  }))
}
// DKS等高级改键发送的行程数据进行转换
export const convertSeniorTravelToSend_Above6800 = (value: SetMagnetSenior): SetMagnetSenior => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return value
  return {
    ...value,
    Keys: value.Keys.map((item) => ({
      ...item,
      Travel: item.Travel > 0 ? item.Travel * 2 : item.Travel,
    })),
  }
}
// DKS等高级改键获取回来的行程数据进行转换
export const convertSeniorTravelFromReceive_Above6800 = (magenet: { [index: KK]: SetMagnetSenior }): { [index: KK]: SetMagnetSenior } => {
  if (!specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) return magenet
  const result: { [index: KK]: SetMagnetSenior } = {}
  for (const key in magenet) {
    const item = magenet[key]
    result[key] = {
      ...item,
      Keys: item.Keys.map((k) => ({
        ...k,
        Travel: k.Travel > 0 ? k.Travel / 2 : k.Travel,
      })),
    }
  }
  return result
}
// 导入配置时行程转换
export const importConfigTravelClampValue = (value: number, min: number, max: number): number => {
  if (specialCheckCurrent(speciaBehiver.DeviceTravelAbove6800)) {
    return (Math.max(min, Math.min(value, max)) * 2) / 10
  }
  return Math.max(min, Math.min(value, max))
}
